export default {
    loanAmount: 10000,
}